
import StepForm from 'zunzun/flyhtml/step/form.mjs'

import AES from 'zunzun/flypto/aes.mjs'
import RSA from 'zunzun/flypto/rsa.mjs'

import EmailUtil from 'zunzun/flyutil/email.mjs'

import raw_html from './html/signup.njk'
import lang from './lang.mjs'

import Fingerprint from './fingerprint/index.js'


export default class SignIn {
  constructor(config) {
    if (!config) config = {};
    if (!config.success_path) config.success_path = "/"
    const lkey = config.lang || "en"

    let form_steps = [
      {
        type: "text",
        name: "username",
        placeholder: lang[lkey].signin.placeholder.username,
        verify: async function(value, values, errcb) {
          try {
            if (value.match(/^[A-Za-z0-9_.-]+$/)) {
              return true;
            }
            errcb(lang[lkey].signin.error.invalid_username)
            return false;
          } catch (e) {
            console.error(e.stack);
            return false;
          }
        }
      },
      {
        type: "password",
        name: "password",
        placeholder: lang[lkey].signin.placeholder.pwd,
        verify: async function(value, values, errcb) {
          try {
            if (value.length > 4) {
              return true;
            }
            errcb(lang[lkey].signin.error.pwd_too_short)
            return false;
          } catch (e) {
            console.error(e.stack);
            return false;
          }
        }
      }
    ];

    const step_form = new StepForm({
      instructions: config.instructions == false ? " " : lang[lkey].signin.instructions
    }, form_steps, async function(values) {
      try {
        if (!config.path_prefix) config.path_prefix = ""
    //    step_form.display_loading();

        // TODO: error out explaining about missing pub key

        const pub_key = FLYAUTH_PUBLIC_KEY;

        // TODO: error out explaining about missing pub key
        
        const rsa = new RSA(pub_key.replace(/\\n/g, "\r\n"));
        let secret_aes = new AES();
        const fingerprint = Fingerprint.get()
        const fp_aes = new AES(AES.seeded_key(fingerprint));


        const key_aes = new AES();
        const session_key = fp_aes.encrypt(key_aes.key);


        const authorized_param = rsa.encrypt(JSON.stringify({
          secret: secret_aes.key,
          fingerprint: fingerprint,
          key: session_key
        }));

        const enc_sess_data = await fetch(config.path_prefix+'/flyauth/init-session', {
          method: 'POST',
          body: `authorized=${authorized_param}`
        }).then(response => response.text());

        const sess_data = JSON.parse(secret_aes.decrypt(enc_sess_data));

        let enc_aes = new AES(sess_data.enc_key);


        localStorage.setItem(FLYAUTH_PREFIX+"flyauth_session_key", session_key);


        secret_aes = new AES();
        values.secret = secret_aes.key;
        values.fingerprint = fingerprint;
        values.tab_id = sess_data.tab_id;
        values.csrf_secret = sess_data.csrf_secret;

        const response = await fetch(config.path_prefix+'/flyauth/signin', {
          method: 'POST',
          body: `cks=${sess_data.cks}&authorized=${encodeURIComponent(enc_aes.encrypt(JSON.stringify(values)))}`
        }).then((response) => {
          if (!response.ok) {
            step_form.err_cb(lang[lkey].signin.error.auth_error);
            return false;
          } else {
            return response.text()
          }
        });
        console.log(response);

        if (typeof response === "string") {
          const resp_dec = JSON.parse(secret_aes.decrypt(response));

          const csrf_secret = resp_dec.csrf_secret;

          const creds = {
            fingerprint: values.fingerprint,
            tab_id: sess_data.tab_id,
            csrf_secret: resp_dec.csrf_secrets[0]
          }

          window.location.href = config.success_path+`/index.html?cks=${sess_data.cks}&authorized=${encodeURIComponent(enc_aes.encrypt(JSON.stringify(creds)))}`;
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.error(e);
      }

    });
    this.element = step_form.element;
  }
}
